import React from 'react'
import { axios } from 'api'
import { camelToSnake } from 'utils'
import { dispatchProgramAction } from './ProgramButtonActions'
import { ProgramStart, StartMainContainer } from './ProgramComponents'

const StartProgram = ({ id, setStatus = () => {} }) => {
  const startProgram = async () => {
    try {
      const res = await axios.post(`programs/${id}/start`)
      setStatus('in_progress')
      dispatchProgramAction('start')
      if (res.status === 200) {
      }
      if (res?.data?.ga4Event) {
        window.dataLayer ||= []
        window.dataLayer.push(camelToSnake(res.data?.ga4Event))
      }
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <StartMainContainer>
      <ProgramStart id='program-start-button' onClick={startProgram}>
        Start program
      </ProgramStart>
    </StartMainContainer>
  )
}

export default StartProgram
